<template>
  <div class="flex sm:flex-row flex-col pb-4 sm:pb-0 justify-between">
    <vue3-tags-input
      v-model="tag"
      :tags="tags"
      :placeholder="$t('Search for insider trades')"  
      class="mb-4 sm:w-1/4 w-full dark:text-custom-purple-100 text-custom-purple-500 "
      @on-remove="removeTag"
      @on-tags-changed="search"
    />
    <div class="flex flex-col sm:flex-row sm:space-x-2">
      <RoundedButton
        class=" bg-gradient-to-tl from-white dark:from-custom-purple-300 to-custom-purple-150 border-none shadow-md dark:shadow-none my-2 sm:my-0 h-10"
        no-shadow
        @click="search(['Acquisitions'])"
      >
        # Acquistions
      </RoundedButton>
      <RoundedButton
        class=" bg-gradient-to-tl from-white dark:from-custom-purple-300 to-custom-purple-150 border-none shadow-md dark:shadow-none my-2 sm:my-0 h-10"
        no-shadow
        @click="search(['Subscribes'])"
      >
        # Subscribes
      </RoundedButton>
      <RoundedButton
        class=" bg-gradient-to-tl from-white dark:from-custom-purple-300 to-custom-purple-150 border-none shadow-md dark:shadow-none my-2 sm:my-0 h-10"
        no-shadow
        @click="search(['Disposals'])"
      >
        # Disposals
      </RoundedButton>
    </div>
  </div>
  <BaseCard padding="p-0">
    <template #body>
      <div class="relative h-full ">
        <Title
          class="flex items-center pr-6 relative pb-2"
          :class="edit ? '' : ''"
        >
          <div class="inline px-6 pt-6">
            <span class=" text-lg font-bold  dark:text-custom-purple-100 text-custom-purple-500">{{ $t('Insider trades') }}</span>
          </div>
        </Title>

        <div
          v-if="loading"
          class="flex justify-center my-10"
        >
          <Loader />
        </div> 

        <div
          v-else
          class=" max-h-80 overflow-y-auto"
          :class="insiders.length > 0 ? '' : 'pt-16'"
        >
          <div v-if="insiders.length > 0">
            <div class="pb-2 ">
              <InsiderTradeContainer
                v-for="insider in insiders"
                :key="'insider-' + insider.id + insider.publish_date"
                :insider="insider"
              />
            </div>
          </div>
          <div
            v-else
            class=" py-4 absolute inset-0 flex justify-center items-end dark:text-custom-purple-100 text-custom-purple-500 font-medium"
          >
            {{ $t('No insider trade information available for this company') }}
          </div>
        </div>
        <!-- <div
        v-if="loading"
        class="flex justify-center my-10"
      >
        <Loader />
      </div>
      <template v-else> -->
        <!-- <InsiderTradeContainer
          v-for="insider in insiders"
          :key="'insider-' + insider.id + insider.publish_date"
          :insider="insider"
        /> -->
      </div>
      <!-- </template> -->
    </template>
  </BaseCard>
</template>

<script>
import Vue3TagsInput from 'vue3-tags-input'

import InsiderTradeContainer from '@/modules/insiderTrade'
import eventBus from '@/js/eventbus'
import { useInsidersStore } from '../../stores/insiders'
import { useCompaniesStore } from '../../stores/companies'

export default {
  name: 'InsiderTradesModule',
  components: {
    InsiderTradeContainer,
    Vue3TagsInput
  },
  props: {
    insideCompany: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const companiesStore = useCompaniesStore()
    const insidersStore = useInsidersStore()

    return { companiesStore, insidersStore }
  },
  data () {
    return {
      tag: '',
      tags: [],
      searchText: ''
    }
  },
  computed: {
    company() {
      return this.companiesStore.selectedCompany
    },
    insiders() {
      
      // console.log('test test', this.insidersStore.insiders)
      return this.insidersStore.insiders
    },
    loading() {
      return this.insidersStore.loading
    },
    loadingMore() {
      return this.insidersStore.loadingMore
    },
    nextPageUrl() {
      return this.insidersStore.nextPageUrl
    }
  },
  created () {
    if (!this.insideCompany && localStorage.insiderTags) {
      const tags = JSON.parse(localStorage.insiderTags)
      this.restoreTags(tags)
      this.search(tags)
    } else {
      this.fetch()
    }
  },
  mounted () {
    if (!this.insideCompany) {
      this.scroll()
    } else {
      // console.log('bottom : ', document.documentElement.scrollTop)
      eventBus.$on('bottom-of-window', (bottomOfWindow) => {
        this.scrollFetch(bottomOfWindow)
      })
    }
  },
  methods: {
    search (newTags) {
      if(newTags && newTags.length > 0) {
        if(!this.tags.includes(newTags[newTags.length - 1])) this.tags.push(newTags[newTags.length - 1])
        localStorage.insiderTags = JSON.stringify(this.tags)
        this.fetch(this.getTagString(this.tags))
      }
    },
    getTagString (tags) {
      if (tags.length === 0) {
        return ''
      }
      const searches = tags.map((tag) => tag.toLowerCase())
      return searches.join(';')
    },
    fetch (search = '') {
      if (this.$route.params.id) {
        this.insidersStore.fetch({ search: search, companyId: this.$route.params.id })
      } else {
        this.insidersStore.fetch({ search: search, companyId: null })
      }
    },
    scrollFetch (bottomOfWindow) {
      if (bottomOfWindow && !this.loadingMore && !this.loading && this.nextPageUrl) {
        if (this.$route.params.id) {
          this.insidersStore.scroll({
            search: this.getTagString(this.tags),
            companyId: this.$route.params.id
          })
        } else {
          this.insidersStore.scroll({ search: this.getTagString(this.tags), companyId: null })
        }
      }
    },
    scroll () {
      window.onscroll = () => {
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight >= document.body.scrollHeight * 0.7
        this.scrollFetch(bottomOfWindow)
      }
    },
    removeTag(tag) {
      this.tags.splice(tag, 1)
      localStorage.insiderTags = JSON.stringify(this.tags)
      this.fetch(this.getTagString(this.tags))
    },
    restoreTags (tags) {
      this.tags = tags
    }
  }
}
</script>

<style lang="scss">
  .v3ti {
    @apply border-none sm:rounded-3xl dark:shadow-none shadow-md min-h-[40px] flex items-center dark:bg-custom-purple-400 dark:text-custom-purple-100 text-custom-purple-500

  }
  .v3ti .v3ti-tag {
    @apply bg-custom-purple-500 text-custom-purple-100 rounded-2xl font-semibold ml-2
  }
  
  .v3ti .v3ti-new-tag {
    @apply text-custom-purple-500 dark:text-custom-purple-100 font-semibold pl-4 placeholder-custom-purple-500 dark:placeholder-custom-purple-100
  }
  
  
</style>
